var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M6,10 L6,7 C6,3.6862915 8.6862915,1 12,1 C15.3137085,1 18,3.6862915 18,7 L18,10 L19,10 C20.6568542,10 22,11.3431458 22,13 L22,20 C22,21.6568542 20.6568542,23 19,23 L5,23 C3.34314575,23 2,21.6568542 2,20 L2,13 C2,11.3431458 3.34314575,10 5,10 L6,10 Z M8,10 L16,10 L16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 L8,10 Z M5,12 C4.44771525,12 4,12.4477153 4,13 L4,20 C4,20.5522847 4.44771525,21 5,21 L19,21 C19.5522847,21 20,20.5522847 20,20 L20,13 C20,12.4477153 19.5522847,12 19,12 L5,12 Z"}));
}

Lock.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Lock;

Lock.default = Lock;
